var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBip = function SvgBip(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 71,
    viewBox: "0 0 200 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.14,
    y1: 0.5,
    x2: 0.86,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da251d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#89211b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-bip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bip",
    clipPath: "url(#clip-bip)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,0H59.7V46H0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2337"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect2339",
    width: 200,
    height: 70.004,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2345",
    d: "M1075.23,1408.247H1122.7l12.234,12.419v-39.857h-59.7v27.439Zm31.029-49.017a1.271,1.271,0,0,0-1.271,1.271v7.583c0,.005,0,.01,0,.015a5.223,5.223,0,1,0,2.541-4.48V1360.5a1.271,1.271,0,0,0-1.272-1.271Zm3.936,6.19a2.664,2.664,0,1,1-2.664,2.664,2.667,2.667,0,0,1,2.664-2.664Zm7.823-2.533a1.272,1.272,0,0,0-1.272,1.272v4.347c0,1.542.217,3.7,2.09,4.643a1.272,1.272,0,1,0,1.143-2.272c-.171-.085-.69-.348-.69-2.371v-4.347a1.271,1.271,0,0,0-1.271-1.272Zm0-3.652a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,1118.018,1359.235Zm6.556,16.113v-2.806a5.2,5.2,0,1,0-2.544-4.465v7.271a1.272,1.272,0,0,0,2.544,0Zm2.664-9.935a2.663,2.663,0,1,1-2.664,2.663,2.667,2.667,0,0,1,2.664-2.663Zm-52.008-14.752v2.591h59.7v-2.591Z",
    transform: "translate(-1075.23 -1350.662)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2347",
    transform: "translate(63.662 3.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2349",
    d: "M2203.617,1417.806c-2.141,0-2.889-1.312-2.889-3.249v-7.7h1.405v4.359h.032a2.069,2.069,0,0,1,1.937-1.188c2.171,0,2.53,2.266,2.53,3.968,0,2.062-.7,3.812-3.015,3.812Zm.094-6.686c-1.187,0-1.578,1.859-1.578,2.781,0,1.016-.031,2.812,1.407,2.812,1.374,0,1.531-1.75,1.531-2.766,0-.875-.125-2.828-1.36-2.828Z",
    transform: "translate(-2200.727 -1406.855)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2351",
    d: "M2339.36,1408.447v-1.594h1.687v1.594Zm.141,9.186V1410.2h1.406v7.437Z",
    transform: "translate(-2331.518 -1406.853)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2353",
    d: "M2416.382,1473.391V1471.8h-.031a2.447,2.447,0,0,1-2.359,1.765c-1.5,0-2-1.156-2-2.453v-5.156h1.407v4.062c0,.312,0,.609.015.922.047.7.2,1.219,1,1.219,1.375,0,1.968-1.953,1.968-3.046v-3.156h1.406v7.437Z",
    transform: "translate(-2400.042 -1462.612)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2355",
    d: "M2562.256,1417.633v-10.779h1.407v10.779Z",
    transform: "translate(-2541.807 -1406.854)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2357",
    d: "M2625.805,1466.263c0,1.672.86,3.344,2.734,3.344a3.878,3.878,0,0,0,1.407-.266v1.109a8.328,8.328,0,0,1-1.859.25c-2.656,0-3.686-1.812-3.686-4.249,0-2.031.891-3.531,3.03-3.531,1.813,0,2.687,1.281,2.687,2.984v.359Zm2.907-.937a1.276,1.276,0,0,0-1.36-1.312,1.436,1.436,0,0,0-1.375.859,1.193,1.193,0,0,0-.11.453Z",
    transform: "translate(-2600.436 -1459.749)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2359",
    d: "M2749.192,1423.275v3.968c0,.828.2,1.453,1.188,1.453a2.421,2.421,0,0,0,.749-.109v1.094a5.236,5.236,0,0,1-1.109.109c-1.311,0-2.233-.39-2.233-1.812v-4.7h-1.329v-1.094h1.329v-1.749l1.405-.875v2.625h2.063v1.094h-2.063Z",
    transform: "translate(-2715.59 -1418.839)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2361",
    d: "M2842.685,1476.6h-1.375l1.046-3.156-2.827-7.483h1.562l1.953,5.374h.032l1.75-5.374h1.562Z",
    transform: "translate(-2803.397 -1462.614)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2363",
    d: "M2988.923,1470.526v-4.062c0-.3,0-.609-.014-.922-.047-.687-.2-1.218-1-1.218-1.375,0-1.968,1.953-1.968,3.047v3.156h-1.407v-7.437h1.407v1.594h.031a2.471,2.471,0,0,1,2.359-1.766c1.484,0,2,1.156,2,2.453v5.156Z",
    transform: "translate(-2940.198 -1459.746)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2365",
    d: "M2203.758,1692.684v-1.594h1.687v1.594Zm.141,9.186v-7.436h1.406v7.436Z",
    transform: "translate(-2203.586 -1675.012)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2367",
    d: "M2282.152,1754.763V1750.7c0-.3,0-.609-.015-.922-.047-.687-.2-1.218-1-1.218-1.375,0-1.968,1.953-1.968,3.046v3.155h-1.407v-7.436h1.407v1.594h.031a2.471,2.471,0,0,1,2.359-1.766c1.484,0,2,1.156,2,2.453v5.155Z",
    transform: "translate(-2273.405 -1727.906)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2369",
    d: "M2416.021,1689.365a5.235,5.235,0,0,0-1.483-.219c-1,0-1.453.734-1.453,1.656v.765h2.218v1.094h-2.218V1699h-1.407v-6.343h-1.344v-1.094h1.344v-.859c0-1.859,1.063-2.656,2.844-2.656a6.848,6.848,0,0,1,1.5.141v1.172Z",
    transform: "translate(-2398.478 -1672.147)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2371",
    d: "M2517.764,1754.933c-2.39,0-3.3-1.7-3.3-3.89,0-2.171.907-3.89,3.3-3.89s3.281,1.719,3.281,3.89S2520.139,1754.933,2517.764,1754.933Zm0-6.686c-1.547,0-1.733,1.594-1.733,2.8,0,1.188.186,2.8,1.733,2.8,1.531,0,1.719-1.625,1.719-2.8S2519.311,1748.247,2517.764,1748.247Z",
    transform: "translate(-2496.721 -1727.905)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2373",
    d: "M2668.465,1748.685c-1.8,0-2.328,1.3-2.328,2.922v3.155h-1.405v-7.436h1.405v1.5h.032a2.329,2.329,0,0,1,2.3-1.672v1.531Z",
    transform: "translate(-2638.486 -1727.905)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2375",
    d: "M2767.873,1754.763V1750.7c0-.265,0-.562-.015-.859-.047-.719-.157-1.281-1.015-1.281-1.095,0-1.641,1.8-1.641,2.64v3.562H2763.8V1750.7c0-.265,0-.562-.015-.859-.047-.687-.126-1.281-.969-1.281-1.235,0-1.688,2.124-1.688,3.046v3.155h-1.407v-7.436h1.407v1.484h.031a2.187,2.187,0,0,1,2.079-1.656,1.759,1.759,0,0,1,1.89,1.578h.031a2.271,2.271,0,0,1,2.108-1.578c1.5,0,2.016,1.156,2.016,2.453v5.155Z",
    transform: "translate(-2728.099 -1727.906)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2377",
    d: "M2967.331,1754.763v-.921h-.032a2.124,2.124,0,0,1-1.921,1.093,1.91,1.91,0,0,1-2.11-2c0-2.093,2.453-2.437,4.063-2.437v-1.3a1.416,1.416,0,0,0-.063-.25,1.036,1.036,0,0,0-1.079-.7,1.064,1.064,0,0,0-1.187,1.14h-1.484c0-1.656,1.3-2.234,2.781-2.234a2.133,2.133,0,0,1,2.437,2.391v5.218Zm0-3.328h-.281c-.876,0-2.22.391-2.22,1.453a.891.891,0,0,0,.813.953,1.978,1.978,0,0,0,1.688-1.984v-.422Z",
    transform: "translate(-2920.136 -1727.906)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2379",
    d: "M3097.026,1749.747c0-.766-.218-1.5-1.14-1.5-1.188,0-1.517,1.328-1.517,2.265,0,1.875.922,3.328,2.954,3.328a3.768,3.768,0,0,0,1.187-.156v.968a7.067,7.067,0,0,1-2.063.281c-2.5,0-3.64-1.859-3.64-4.156,0-2.062.938-3.625,3.172-3.625a2.372,2.372,0,0,1,2.655,2.593Z",
    transform: "translate(-3042.35 -1727.905)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2381",
    d: "M3190.7,1702.51c0,2-1.517,2.7-3.3,2.7a3.519,3.519,0,0,1-.406-.031v-1.109a3.412,3.412,0,0,0,.561.047c1.563,0,1.735-.891,1.735-2.2v-7.483h1.407v8.077Zm-1.547-9.826v-1.594h1.688v1.594Z",
    transform: "translate(-3131.209 -1675.013)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2383",
    d: "M3297.458,1692.684v-1.594h1.688v1.594Zm.141,9.186v-7.436h1.406v7.436Z",
    transform: "translate(-3235.424 -1675.012)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2385",
    d: "M3459.43,1754.933a2.046,2.046,0,0,1-1.984-1.187h-.032v4.358h-1.405v-10.779h1.405v1.125h.032a2.261,2.261,0,0,1,2.062-1.3c2.047,0,2.546,2.093,2.546,3.765,0,1.687-.5,4.015-2.624,4.015Zm-.422-6.686c-1.266,0-1.594,1.859-1.594,2.812,0,1.046.234,2.781,1.625,2.781,1.329,0,1.453-1.828,1.453-2.8,0-1-.11-2.8-1.484-2.8Z",
    transform: "translate(-3385.006 -1727.905)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2387",
    d: "M3599.841,1757.632v-1.593h-.032a2.446,2.446,0,0,1-2.359,1.765c-1.5,0-2-1.156-2-2.453V1750.2h1.407v4.062c0,.312,0,.609.016.922.047.7.2,1.219,1,1.219,1.375,0,1.969-1.953,1.969-3.046V1750.2h1.405v7.436Z",
    transform: "translate(-3516.56 -1730.775)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2389",
    d: "M3743.093,1702.04c-2.141,0-2.889-1.312-2.889-3.249v-7.7h1.405v4.359h.032a2.069,2.069,0,0,1,1.937-1.188c2.171,0,2.53,2.266,2.53,3.968,0,2.062-.7,3.812-3.016,3.812Zm.094-6.686c-1.187,0-1.578,1.859-1.578,2.781,0,1.015-.031,2.812,1.406,2.812,1.375,0,1.531-1.75,1.531-2.766,0-.875-.125-2.827-1.36-2.827Z",
    transform: "translate(-3653.127 -1675.011)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2391",
    d: "M3881.322,1701.87v-10.779h1.408v10.779Z",
    transform: "translate(-3786.263 -1675.013)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2393",
    d: "M3953.124,1692.684v-1.594h1.688v1.594Zm.141,9.186v-7.436h1.406v7.436Z",
    transform: "translate(-3854.003 -1675.012)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2395",
    d: "M4021.715,1749.747c0-.766-.218-1.5-1.14-1.5-1.187,0-1.515,1.328-1.515,2.265,0,1.875.921,3.328,2.952,3.328a3.76,3.76,0,0,0,1.187-.156v.968a7.055,7.055,0,0,1-2.062.281c-2.5,0-3.64-1.859-3.64-4.156,0-2.062.937-3.625,3.171-3.625a2.373,2.373,0,0,1,2.656,2.593Z",
    transform: "translate(-3914.736 -1727.905)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2397",
    d: "M4132.373,1757.632v-1.094l3.609-5.249h-3.374V1750.2h5.077v1.063l-3.61,5.28h3.75v1.094Z",
    transform: "translate(-4023.113 -1730.776)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2399",
    d: "M4262.148,1754.763V1750.7c0-.3,0-.609-.015-.922-.047-.687-.2-1.218-1-1.218-1.374,0-1.968,1.953-1.968,3.046v3.155h-1.406v-7.436h1.406v1.594h.031a2.471,2.471,0,0,1,2.359-1.766c1.484,0,2,1.156,2,2.453v5.155Z",
    transform: "translate(-4141.407 -1727.906)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2401",
    d: "M4395.918,1750.5c0,1.672.86,3.344,2.734,3.344a3.874,3.874,0,0,0,1.406-.266v1.109a8.331,8.331,0,0,1-1.859.25c-2.657,0-3.687-1.812-3.687-4.249,0-2.031.891-3.531,3.03-3.531,1.813,0,2.687,1.281,2.687,2.984v.359Zm2.907-.937a1.276,1.276,0,0,0-1.36-1.312,1.437,1.437,0,0,0-1.375.859,1.2,1.2,0,0,0-.11.453Z",
    transform: "translate(-4270.426 -1727.905)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2403",
    d: "M4497.065,1702.51c0,2-1.517,2.7-3.3,2.7a3.519,3.519,0,0,1-.406-.031v-1.109a3.412,3.412,0,0,0,.561.047c1.563,0,1.735-.891,1.735-2.2v-7.483h1.407v8.077Zm-1.547-9.826v-1.594h1.688v1.594Z",
    transform: "translate(-4363.684 -1675.013)",
    fillRule: "evenodd"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bip.4c0c40c4.svg";
export { ForwardRef as ReactComponent };